import React from 'react';
import { User, Building2 } from 'lucide-react';

interface StepClientTypeProps {
    tipo: 'PF' | 'PJ';
    onChange: (tipo: 'PF' | 'PJ') => void;
    onNext: () => void;
}

const StepClientType: React.FC<StepClientTypeProps> = ({ tipo, onChange, onNext }) => {
    return (
        <div className="flex flex-col gap-6 animate-fade-in">
            <div className="text-center mb-4">
                <h3 className="text-lg font-bold text-gray-800 dark:text-slate-100">Qual o tipo de cliente?</h3>
                <p className="text-sm text-gray-500 dark:text-slate-400">Selecione para configurar os campos corretamente.</p>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <button
                    onClick={() => onChange('PF')}
                    className={`flex flex-col items-center justify-center gap-3 p-6 rounded-2xl border-2 transition-all ${tipo === 'PF'
                        ? 'border-primary bg-primary/5 text-primary'
                        : 'border-gray-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-gray-400 dark:text-slate-500 hover:border-gray-200 dark:hover:border-slate-600 hover:bg-gray-50 dark:hover:bg-slate-800'
                        }`}
                >
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center ${tipo === 'PF' ? 'bg-primary text-white' : 'bg-gray-100 dark:bg-slate-800'
                        }`}>
                        <User size={24} />
                    </div>
                    <span className="font-bold">Pessoa Física</span>
                </button>

                <button
                    onClick={() => onChange('PJ')}
                    className={`flex flex-col items-center justify-center gap-3 p-6 rounded-2xl border-2 transition-all ${tipo === 'PJ'
                        ? 'border-primary bg-primary/5 text-primary'
                        : 'border-gray-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-gray-400 dark:text-slate-500 hover:border-gray-200 dark:hover:border-slate-600 hover:bg-gray-50 dark:hover:bg-slate-800'
                        }`}
                >
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center ${tipo === 'PJ' ? 'bg-primary text-white' : 'bg-gray-100 dark:bg-slate-800'
                        }`}>
                        <Building2 size={24} />
                    </div>
                    <span className="font-bold">Pessoa Jurídica</span>
                </button>
            </div>

            <div className="flex justify-end mt-4">
                <button
                    onClick={onNext}
                    className="px-6 py-2.5 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 transition-colors shadow-lg shadow-primary/20"
                >
                    Próximo
                </button>
            </div>
        </div>
    );
};

export default StepClientType;
